import { z } from "zod";

const columnFilters = z
	.array(z.object({ id: z.string(), value: z.unknown() }))
	.optional()
	.catch(undefined);

/** Widok połączeń w URL — po odświeżeniu wraca ten sam filtr. */
export const mcpAdminSearchSchema = z.object({
	inactive: z.boolean().default(false).catch(false),
	connectionFilters: columnFilters,
});

export type McpAdminSearch = z.infer<typeof mcpAdminSearchSchema>;
